<div class="row">
  <!-- <label for="reference" class="form-label">{{
    "pages.invoice.searchOrders" | translate
    }}</label> -->
  <div class="form">
    <form [formGroup]="form">
      <div class="row">
        <div class="col-6">
          <div class="mb-3">
            <label for="broker_reference" class="form-label">{{
              "inputs.reference" | translate
              }}</label>
            <input type="text" class="form-control" id="broker_reference" required formControlName="broker_reference"
              placeholder="{{
                'inputs.reference' | translate
              }}" />
          </div>
        </div>
        <div class="col-3">
          <div class="mb-3">
            <label for="brand" class="form-label">{{ "inputs.brand" | translate }}
              <span class="required">*</span></label>
            <ng-select formControlName="vehicle_brand_id" [items]="brands" bindValue="reference" bindLabel="name"
              [placeholder]="'inputs.brand' | translate" [searchable]="true" [clearable]="false">
            </ng-select>
          </div>
        </div>
        <div class="col-3">
          <div class="mb-3">
            <label for="vehicle_status" class="form-label">{{
              "inputs.status" | translate
              }}</label>
            <div class="input-group">
            <select id="vehicle_status" class="form-control" formControlName="vehicle_status">
              <option value="" disabled selected>
                {{ "inputs.select_option" | translate }}
              </option>
              <option value="new">
                {{ "badge-status_select-stage.new" | translate }}
              </option>
              <option value="used">
                {{ "badge-status_select-stage.used" | translate }}
              </option>
            </select>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-4">
          <div class="mb-3">
            <label for="start_date" class="form-label">{{
              "inputs.start_date" | translate
              }}</label>

            <mat-form-field appearance="fill">
              <input matInput [matDatepicker]="start_date"
                formControlName="start_date" placeholder="{{
                  'inputs.start_date' | translate
                }}" />
              <mat-datepicker-toggle matSuffix [for]="start_date"></mat-datepicker-toggle>
              <mat-datepicker #start_date></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
        <div class="col-4">
          <div class="mb-3">
            <label for="end_date" class="form-label">{{
              "inputs.end_date" | translate
              }}</label>

            <mat-form-field appearance="fill">
              <input matInput [matDatepicker]="end_date"
                formControlName="end_date" placeholder="{{
                  'inputs.end_date' | translate
                }}" />
              <mat-datepicker-toggle matSuffix [for]="end_date"></mat-datepicker-toggle>
              <mat-datepicker #end_date></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
        <div class="col-4">
          <div class="mb-3">
            <label for="stage" class="form-label">{{
              "inputs.stage" | translate
              }}</label>
            <ng-select formControlName="stage" [items]="stageOptions" bindValue="key"
              [placeholder]="'inputs.select_option' | translate" [searchable]="true" [clearable]="false">
              <ng-template ng-label-tmp let-item="item">{{ "badge-status_select-stage." + item.key | translate }}</ng-template>
              <ng-template ng-option-tmp let-item="item">{{ "badge-status_select-stage." + item.key | translate }}</ng-template>
            </ng-select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="mb-3">
            <div class="btn-izq">
              <button class="btn btn-hover" type="button" (click)="search()">
                {{ "buttons.searchInvoice" | translate }} <i class="icon-magnifier"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
    <div class="row linea"></div>
  </div>
</div>
